const CAROUSEL_ITEMS = [
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20manhwa%20illustration%20with%20sword%20warrior%20in%20dramatic%20pose%2C%20glowing%20aura%2C%20dark%20fantasy%20style%2C%20Korean%20webtoon%20aesthetic%2C%20warm%20orange%20and%20crimson%20tones%2C%20cinematic%20lighting%2C%20clean%20simple%20cream%20background&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '编辑精选',
    title: '剑尊归来',
    desc: '一代剑尊重生归来，以绝世剑术横扫天下。每周五更新，热度破亿的现象级韩漫。',
    meta: '连载中 · 热度 9.8',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20shojo%20manga%20style%20illustration%20with%20couple%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20tones%2C%20Japanese%20manga%20aesthetic%2C%20dreamy%20atmosphere%2C%20delicate%20lineart%2C%20clean%20cream%20background&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '人气飙升',
    title: '樱花下的约定',
    desc: '高中最后的春天，一段跨越十年的纯爱物语。日漫恋爱天花板，甜到牙疼。',
    meta: '完结 · 共128话',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cyberpunk%20action%20manga%20illustration%20with%20futuristic%20city%20and%20hunter%20character%2C%20neon%20accents%20on%20dark%20background%2C%20dynamic%20composition%2C%20Korean%20manhwa%20style%2C%20warm%20amber%20highlights%2C%20clean%20simple%20composition&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '本周强推',
    title: '我独自升级',
    desc: '从最弱E级猎人到世界最强，逆天改命的爽快升级之路。韩漫天花板级作品。',
    meta: '连载中 · 热度 9.9',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20with%20cultivation%20warrior%20in%20ancient%20Chinese%20setting%2C%20flowing%20robes%2C%20spiritual%20energy%2C%20warm%20golden%20and%20coral%20tones%2C%20elegant%20brushwork%20style%2C%20clean%20cream%20background&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '国漫之光',
    title: '全职高手',
    desc: '荣耀职业联盟的巅峰传奇，叶修重返赛场的热血征程。国漫电竞题材标杆。',
    meta: '连载中 · 热度 9.7',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20webtoon%20illustration%20with%20detective%20character%20in%20shadowy%20alley%2C%20suspenseful%20atmosphere%2C%20warm%20sepia%20and%20amber%20tones%2C%20Korean%20manhwa%20style%2C%20cinematic%20noir%20lighting%2C%20clean%20simple%20background&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '口碑佳作',
    title: '暗黑法则',
    desc: '连环杀人案背后的惊天阴谋，每话反转让人欲罢不能。悬疑推理类必追神作。',
    meta: '连载中 · 热度 9.5',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            编辑精选
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            编辑部精心挑选的必追佳作，品质保证
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-5">
          {CAROUSEL_ITEMS.map((item, i) => (
            <div
              key={i}
              className="group w-full sm:w-[calc(50%-10px)] lg:w-[calc(33.333%-14px)] xl:w-[calc(20%-16px)] min-w-[240px] rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">{item.desc}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{item.meta}</span>
                  <span className="text-xs text-primary-500 font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap cursor-pointer">
                    立即阅读 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}